import { createRouter, createWebHashHistory } from 'vue-router';
import About from './views/About.vue';
import Resume from './views/Resume.vue';

export default createRouter({
    history: createWebHashHistory(),
    routes: [
        {
            path: '/',
            name: 'About',
            component: About,
            meta: {
                title: 'Home',
                icon: 'mdi-home',
            },
            props: {},
        },
        {
            path: '/resume',
            name: 'Resume',
            component: Resume,
            meta: {
                title: 'Resume',
                icon: 'mdi-file-document',
            },
            props: {},
        },
    ],
});
